export default "__VITE_ASSET__CUKPJPVL__"